import { getConfig } from '../config';
import { safeGetItemFromStorage, safeSetItemToStorage } from './safeSetItemToStorage';

export function getExternalId() {
	let cId = safeGetItemFromStorage('cId');
	if (cId === 'undefined') cId = null; // Фикс одного специфичного кейса
	if (!cId) safeSetItemToStorage('cId', getConfig().cId);
	return cId || getConfig().cId;
}
